import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45766725"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booking-menu-category-page" }
const _hoisted_2 = { class: "card-wrapper gap-3" }
const _hoisted_3 = { class: "card-header-wrapper" }
const _hoisted_4 = { class: "title-3 header-name" }
const _hoisted_5 = { class: "flex justify-content-end" }

import { onMounted, ref } from "vue";
/**
 * Vuexストア
 * アプリケーション全体の状態管理に使用
 */
import { useStore } from "vuex";
/**
 * Vue Router
 * ルーティング情報の取得に使用
 */
import { useRoute } from "vue-router";
/**
 * ルーティングユーティリティ
 * 画面遷移の制御に使用
 */
import RouterUtils from "@/common/utils/router.util";
/**
 * ルーティング定数
 * 画面遷移先の定義に使用
 */
import RouterConstants from "../constants/router.constants";
/**
 * メニューカテゴリーサービス
 * カテゴリー情報の取得に使用
 */
import { MedicalMenuCategoryServices } from "@/customer/services";

/**
 * メニューカテゴリーのリスト
 * @type {Ref<any[]>}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingMenuCategory',
  setup(__props) {

/**
 * 予約メニューカテゴリー画面コンポーネント
 * メニューカテゴリーの一覧表示と選択を行う画面
 * カテゴリーの表示、選択、次画面への遷移機能を提供
 */

/**
 * Vueの基本機能
 * コンポーネントのライフサイクルとリアクティブな状態管理に使用
 */
const bookingMenuCategories = ref();

/**
 * Vuexストアインスタンス
 */
const store = useStore();

/**
 * 予約設定
 * @type {Ref<string>}
 */
const bookingSetting = ref("");

/**
 * ルート情報
 */
const route = useRoute();

/**
 * コンポーネントのマウント時の処理
 * メニューカテゴリーの取得、初期化、編集モードの設定を行う
 */
onMounted(async () => {
  // 基本パラメータに clinic_id を設定
  let params = { clinic_id: store.getters["line_account/clinicId"] };

  // カテゴリ取得APIを呼び出し
  const { data: categories } = await MedicalMenuCategoryServices.fetchCategories(
    params,
    () => undefined,
    () => undefined,
    () => undefined
  );
  // 取得結果を反映
  bookingMenuCategories.value = categories.value;
  // カテゴリがない場合はメニュー選択画面へリダイレクト
  if (bookingMenuCategories.value.length == 0) {
    store.commit("booking/selectMenuCategory", 0);
    RouterUtils.goTo(RouterConstants.BOOKING_MENU_ROUTER_NAME);
  }
  // 予約設定オプションを取得
  const settings = store.getters["bookingSetting/option"];
  bookingSetting.value = settings;

  // 編集モードの判定と設定
  const { edit } = route.query;
  if (!(edit || store.getters["booking/editFlag"])) {
    // 編集モードでない場合は状態をリセット
    store.commit("booking/resetState");
  } else {
    // 編集モードの場合はフラグを設定
    store.commit("booking/setEditFlag", true);
  }
});

/**
 * メニューカテゴリー選択時の処理
 * 選択されたカテゴリーを保存し、メニュー選択画面へ遷移
 * @param {object} category - 選択されたカテゴリー情報
 */
const handleClickCategory = (category: { id: number }) => {
  // 選択されたカテゴリーIDをVuexストアに保存
  store.commit("booking/selectMenuCategory", category.id);
  // メニュー選択画面へ遷移
  RouterUtils.goTo(RouterConstants.BOOKING_MENU_ROUTER_NAME);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingMenuCategories.value, (category) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: category.id,
          class: _normalizeClass({ 'p-card-selected': category.id == _unref(store).getters['booking/selectedMenuCategoryId'] })
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(category.name), 1)
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                class: "accept-btn",
                label: "選択",
                onClick: ($event: any) => (handleClickCategory(category))
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ])
  ]))
}
}

})